import React from 'react';
import PropTypes from 'prop-types';

import { LightBlueAlert } from '../../../commons/Alerts';
import AddressFieldsSection from './AddressFieldsSection';

const ConsultantInvoiceMailChequePaymentSection = ({ consultantCountry }) => (
    <div>
        <div className="mb-2">
            <LightBlueAlert>
                Check payments have an unexpectedly high processing time. For
                faster invoice payment, please select <b>Bank Payment</b> mode.
            </LightBlueAlert>
        </div>

        <AddressFieldsSection
            fieldName="consultantInvoiceChequeDetails.beneficiaryAddress"
            consultantCountry={consultantCountry}
        />
    </div>
);

ConsultantInvoiceMailChequePaymentSection.propTypes = {
    consultantCountry: PropTypes.string.isRequired,
};

export default ConsultantInvoiceMailChequePaymentSection;
